var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoticePrimary3636 = function SvgNoticePrimary3636(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    x: 1.5,
    y: 1.5,
    stroke: "#669AFF",
    strokeWidth: 3,
    rx: 16.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#669AFF",
    d: "M16.5 10.5h3v10h-3zM16.5 22.5h3v3h-3z"
  })));
};
export default SvgNoticePrimary3636;